var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{staticClass:"pointer",staticStyle:{"width":"100%"},attrs:{"src":require("@/assets/bill/banner.png")},on:{"click":_vm.$login}}),_c('text-left',{attrs:{"text-left":{
      height: 420,
      title: '应交增值税查询',
      desc: '通过筝鸣，您可以随时查看到您的应交增值税额，从而实现更好地现金流管理。',
      textWidth: 550,
      imgWidth: 510,
      left: false,
      img: require('@/assets/bill/img2.png')
    }}}),_c('text-left',{attrs:{"text-left":{
      height: 490,
      title: '增值税进项发票管理',
      desc: '筝鸣帮您精确跟踪每笔增值税进项发票，清楚掌握当月可抵扣进项税额，避免因进项发票丢失和未收到造成多缴税。',
      textWidth: 600,
      imgWidth: 430,
      left: true,
      img: require('@/assets/bill/img1.png')
    }}}),_c('text-left',{attrs:{"text-left":{
      height: 550,
      title: '增值税销项发票管理',
      desc: '客户开票信息可提前维护进系统。开票时，信息查找更加快捷方便。同时，应缴增值税信息精准掌控，业务动态及时了解。',
      textWidth: 680,
      imgWidth: 400,
      left: false,
      img: require('@/assets/bill/img3.png')
    }}}),_c('part-list',{attrs:{"part-list":_vm.list}}),_c('Ready')],1)}
var staticRenderFns = []

export { render, staticRenderFns }